import loyalityBg from "../Assests/Images/loyalty-bg.png";

export const pageStyles = (theme) => ({
  loyaltyPointsDiv: {
    backgroundImage: `url(${loyalityBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "14vh",
    borderRadius: 1,
  },

  loyalityPoints: {
    color: theme.palette.primary.main,
  },

  cardDiv: {
    position: "relative",
    borderRadius: 1,
    overflow: "hidden",
  },

  hoverImg: {
    objectFit: "cover",
    "&:hover": { transform: "scale(1.05)" },
    transition: "transform 0.3s ease",
  },

  btnDiv: {
    position: "absolute",
    bottom: "-10px",
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    pointerEvents: "none",
  },

  tapBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.primary,
    pointerEvents: "auto",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    width: "100%",
  },

  quickStatsDiv: {
    borderRadius: 1,
    p: 2,
    height: "100%",
  },

  quickStatsHeading: {
    fontSize: theme.palette.textSize.lg,
    fontWeight: "bold",
    color: theme.palette.text.primary,
    mb: 2,
  },

  lookingCard: {
    position: "relative",
    borderRadius: 1,
    overflow: "hidden",
    height: 180,
    cursor: "pointer",
  },

  lookingDiv: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    p: 2,
  },

  walletMainDiv: {
    borderRadius: 1,
    p: 2,
    background: "linear-gradient(135deg, #000000 30%, #1a1a1a 70%)",
    color: theme.palette.text.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    overflow: "hidden",
  },

  walletDiv: {
    position: "absolute",
    bottom: -10,
    right: -10,
    width: "120%",
    height: "60%",
    background: "linear-gradient(90deg, #FFA200, #FF7B00, #FF00FF, #00FFFF)",
    opacity: 0.7,
    filter: "blur(40px)",
    zIndex: 0,
  },

  walletIcon: {
    bgcolor: theme.palette.primary.main,
    width: 40,
    height: 40,
    mr: 2,
    color: theme.palette.text.primary,
  },

  lookingText: {
    ml: 1,
    fontWeight: 500,
    color: theme.palette.text.white,
    fontSize: theme.palette.textSize.xl,
  },

  carouselBtn: {
    color: theme.palette.text.primary,
    boxShadow: 2,
    "&:hover": { boxShadow: 4 },
    "&.Mui-disabled": { opacity: 0.4 },
  },

  themeBtn: {
    borderRadius: 1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.primary,
    px: 2,
    py: 1,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },

  themeBtn1: {
    borderRadius: 1,
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    px: 2,
    py: 1,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },

  flex_center_btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  flex_c: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },

  flex_2c: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },

  flex_c_c: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  flex_start: {
    display: "flex",
    alignItems: "flex-start",
  },

  flex_start_btn: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },

  flex_end: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },

  allBtn: {
    textTransform: "none",
    fontWeight: "bold",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 3,
    px: 2,
    py: 1,
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },

  loyaltyMainDiv: {
    borderRadius: 1,
    p: 2,
  },

  lightTextSmall: {
    color: theme.palette.text.secondary,
    fontSize: theme.palette.textSize.xs,
  },

  lightTextMedium: {
    color: theme.palette.text.secondary,
    fontSize: theme.palette.textSize.md,
  },

  lightTextsmd: {
    color: theme.palette.text.secondary,
    fontSize: theme.palette.textSize.smd,
  },

  themeTextsmd: {
    color: theme.palette.primary.main,
    fontSize: theme.palette.textSize.smd,
  },

  themeTextsmd500: {
    color: theme.palette.primary.main,
    fontSize: "18px",
    fontWeight: 400,
  },

  darkTextSmall: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.xs,
  },

  darkTextsmd: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.smd,
  },

  darkTextsmd500: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.smd,
    fontWeight: 500,
  },

  darkTextMedium: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.md,
  },

  darkTextMedium1: {
    color: "#fff",
    fontSize: theme.palette.textSize.md,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },

  darkTextMedium500: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.md,
    fontWeight: 500,
  },

  darkTextMedium700: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.md,
    fontWeight: 700,
  },

  darkTextSmall500: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.xs,
    fontWeight: 500,
  },

  greyTextsmd: {
    fontSize: theme.palette.textSize.smd,
    color: theme.palette.user.grey,
  },

  inputField: {
    mt: 0,
    backgroundColor: "#f3f3f5",
    borderRadius: "0.6rem",
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.6rem",
      "& fieldset": {
        borderColor: "transparent",
        transition: "border-color 0.3s ease, box-shadow 0.3s ease",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 3px ${theme.palette.primary.main}`,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 3px ${theme.palette.primary.main}`,
      },
    },
  },

  OtpInput: {
    width: 50,
    borderRadius: 1,
    boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.04)",
    bgcolor: "#f3f3f5",
  },

  priceBtn: {
    backgroundColor: "#E0DDDC",
    color: "text.primary",
    textTransform: "none",
    borderRadius: 1,
    px: 1.5,
    py: 0.5,
    border: "1px solid",
    borderColor: "divider",
    mr: 0.5,
    mb: 0.6,
  },

  priceBtn2: {
    backgroundColor: "#fff",
    color: "text.primary",
    textTransform: "none",
    borderRadius: 1,
    px: 1.5,
    py: 0.5,
    border: "1px solid",
    borderColor: "divider",
    mr: 0.5,
    mb: 0.6,
  },

  navigateBtn: {
    backgroundColor: "primary.main",
    color: "white",
    textTransform: "none",
    borderRadius: "0.5",
    px: 1.5,
    py: 0.5,
    width: "80px",
    height: "25px",
    fontSize: "11px",
  },

  filterInactive: {
    borderRadius: 0.5,
    p: 1,
    color: theme.palette.text.primary,
  },

  fuelList: {
    bgcolor: theme.palette.background.paper,
    p: 3,
    borderRadius: 1,
    boxShadow: 0,
    border: `1px solid ${theme.palette.border.thin}`,
    height: "calc(100vh - 25vh)",
    overflowY: "auto",
    paddingBottom: "4rem",
    flex: 1,
  },

  productView: {
    borderRadius: 1,
    bgcolor: "background.paper",
    boxShadow: 0,
    border: `1px solid ${theme.palette.border.thin}`,
    height: "calc(100vh - 25vh)",
    paddingBottom: "4rem",
    overflowY: "auto",
  },

  supportList: {
    bgcolor: theme.palette.background.paper,
    p: 3,
    borderRadius: 1,
    boxShadow: 0,
    border: `1px solid ${theme.palette.border.thin}`,
    overflowY: "auto",
    flex: 1,
  },

  fuelminiList: {
    display: "flex",
    alignItems: "center",
    mb: 2,
    p: 1,
    boxShadow: 0,
    cursor: "pointer",
    border: `1px solid ${theme.palette.border.thin}`,
    "&:hover": {
      transform: "scale(1.02)",
      transition: "transform 0.3s ease",
    },
  },

  fuelminiListActive: {
    display: "flex",
    alignItems: "center",
    mb: 2,
    p: 1,
    boxShadow: 0,
    border: `2px solid ${theme.palette.primary.main}`,
    transform: "scale(1.03)",
    transition: "transform 0.3s ease",
    cursor: "pointer",
  },

  fuelNoList: {
    borderRadius: 1,
    boxShadow: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: 3,
    textAlign: "center",
    bgcolor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.thin}`,
    height: "calc(100vh - 26vh)",
  },

  fuelNoListTitle: {
    color: theme.palette.user.grey,
    mt: 2,
    fontSize: theme.palette.textSize["2xl"],
  },

  fuelNoListDesc: {
    color: theme.palette.user.grey50,
    mt: 2,
    fontSize: theme.palette.textSize.md,
  },



  fav_btn: {
    position: "absolute",
    right: 12,
    top: 12,
    bgcolor: "white",
    width: 36,
    height: 36,
    boxShadow: 1,
    "&:hover": { bgcolor: "white" },
  },

  addCart: {
    borderRadius: 8,
    fontWeight: 600,
  },

  rawHtml: {
    fontSize: "14px",
    color: "#000",
    lineHeight: "1.2",
  },

  profileCard: {
    p: 1.25,
    borderRadius: 1.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    border: `1px solid ${theme.palette.border.thin}`,
    cursor: "pointer",
  },

  profileCardBtn: {
    p: 1.25,
    borderRadius: 1.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    border: "1px solid #dd0404",
    cursor: "pointer",
  },

  logoutBtn: {
    textAlign: "center",
    width: "100%",
    border: "none",
    color: "#dd0404",
  },

  profilePaper: {
    mx: "auto",
    bgcolor: "transparent",
    borderRadius: 2,
  },

  profileHeader: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    my: 3,
  },

  profileAvatar: {
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#fff",
    border: "1px solid rgba(15,12,90,0.1)",
    cursor: "pointer",
    padding: 2,
  },

  avatar: {
    width: 40,
    height: 40,
    color: "#fff",
    mb: 0.5,
  },

  fuelCard: {
    gap: 2,
    p: 1,
    borderRadius: 1,
    border: "2px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
    height: 220,
    cursor: "pointer",
    overflowY: "auto",
  },

  fuelCardImg: {
    width: 80,
    height: 80,
    borderRadius: 0.6,
    objectFit: "contain",
    border: `1px solid ${theme.palette.border.thin}`,
  },

  greenChip: {
    bgcolor: "#B8FFB880",
    color: "#004700",
    border: "none",
    fontWeight: "400",
  },

  filterActive: {
    fontWeight: 600,
    borderRadius: 0.5,
    p: 1,
    color: theme.palette.text.white,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },

  productImg: {
    width: 70,
    height: 70,
    borderRadius: 1,
    mr: 2,
    objectFit: "contain",
    border: `1px solid ${theme.palette.border.thin}`,
  },

  avaiableBtn: {
    bgcolor: "#E6F7EF",
    color: "#027A48",
    height: 28,
    fontWeight: 500,
    borderRadius: 2,
  },

  closedBtn: {
    bgcolor: "#FFEBEB",
    color: "#DD0404",
    height: 28,
    fontWeight: 500,
    borderRadius: 2,
  },

  DrawerImgbg: {
    position: "relative",
    height: 160,
    background: "#eee",
  },

  DrawerImg: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
  },

  closeBtn: {
    position: "absolute",
    right: 10,
    top: 10,
    bgcolor: "rgba(255,255,255,0.92)",
    boxShadow: 1,
    width: 36,
    height: 36,
    "&:hover": { bgcolor: "white" },
  },

  DrawerContent: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },

  avaiable: {
    bgcolor: "#E9FBF0",
    color: "#0FA572",
    border: "none",
    height: 28,
    fontWeight: 600,
  },

  closed: {
    bgcolor: "#FFE9E9",
    color: "#F44336",
    border: "none",
    height: 28,
    fontWeight: 600,
  },

  favIcon: {
    bgcolor: "rgba(255,255,255,0.92)",
    boxShadow: 1,
    width: 40,
    height: 40,
  },

  addressDiv: {
    mt: 2,
    p: 1,
    borderRadius: 2,
    bgcolor: "#F7F7F8",
    width: "100%",
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    alignItems: "center",
    justifyContent: "space-between",
  },

  productBtn: {
    borderRadius: 1,
    px: 1,
    m: 0.4,
    backgroundColor: "#F59E0B10",
    border: "1px solid #F59E0B50",
    color: "#ED6C02",
    fontWeight: 600,
  },

  priceDiv: {
    borderRadius: 1,
    p: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #cccccc50",
    bgcolor: "#fff",
    cursor: "pointer",
    position: "relative",
  },

  priceDivActive: {
    borderRadius: 1,
    p: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #F0F0F0",
    bgcolor: `${theme.palette.primary.main}50`,
    cursor: "pointer",
    position: "relative",
  },

  priceNoData: {
    borderRadius: 1,
    p: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #F0F0F0",
    bgcolor: "#F0F0F0",
    cursor: "pointer",
    position: "relative",
  },

  fuelIcon: {
    width: 40,
    height: 40,
    borderRadius: "0.3rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#fff",
    border: `1px solid ${theme.palette.border.thin}`,
  },

  serviceIcon: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "0.3rem",
  },

  loyalityDiv: {
    mt: 1.2,
    p: 1.2,
    borderRadius: 1.2,
    bgcolor: "#0B1220",
    color: "#fff",
    display: "flex",
    gap: 1,
    alignItems: "center",
  },

  paperDiv: {
    mt: 1.2,
    p: 1.2,
    borderRadius: 1,
  },

  fuelIcon2: {
    width: 50,
    height: 50,
    objectFit: "contain",
    border: `1px solid ${theme.palette.border.thin}`,
    borderRadius: 1,
  },

  editIcon: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.primary,
    borderRadius: 2,
  },

  deliveryIns: {
    p: 1.5,
    borderRadius: 1,
    backgroundColor: "#00A2FF33",
    border: "1px solid #0989D1",
    color: "#0989D1",
    fontSize: theme.palette.textSize.sm,
    my: 2,
  },

  toogleBtn: {
    borderRadius: "50px", // pill shape
    textTransform: "none",
    fontWeight: "bold",
    border: "none",
    color: "black",
    width: "70px",
    height: "30px",
    backgroundColor: "#c0bdbd",
    "&.Mui-selected": {
      backgroundColor: "#FFA500", // orange when selected
      color: "black",
      "&:hover": {
        backgroundColor: "#e69500", // darker orange on hover
      },
    },
    "&:hover": {
      backgroundColor: "#b0adad",
    },
  },

  savedAddDiv: {
    p: 2,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  savedCard: {
    p: 0,
    borderRadius: 1,
    border: `1px solid ${theme.palette.border.thin}`,
    bgcolor: theme.palette.background.paper,
  },

  savedCard1: {
    p: 1,
    borderRadius: 1,
    border: `1px solid ${theme.palette.border.thin}`,
    bgcolor: theme.palette.background.paper,
  },

  addressEdit: {
    alignSelf: "center",
    ml: 1,
    bgcolor: theme.palette.primary.main,
    color: theme.palette.text.primary,
    "&:hover": { bgcolor: "rgba(0,0,0,0.06)" },
  },

  addAddressBtn: {
    bgcolor: theme.palette.primary.main,
    color: theme.palette.text.primary,
    fontWeight: 600,
  },

  cartMyDiv: {
    p: 2,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  plusBtn: {
    backgroundColor: "#FFA500",
    color: "#000",
    borderRadius: "6px",
    "&:hover": { backgroundColor: "#ffb733" },
    width: 28,
    height: 28,
  },

  numberDisplay: {
    backgroundColor: "#ccc",
    width: 28,
    height: 28,
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  errorText: {
    color: theme.palette.error.main,
    fontSize: "0.9rem",
    fontWeight: 600,
    ml: 2,
    mt: 0.5,
  },

  errorText2: {
    color: theme.palette.error.main,
    fontSize: "0.65rem",
    fontWeight: 500,
  },

  orderStatus: {
    p: 2,
    borderRadius: 1,
    border: "1px solid #F2B8B8",
  },

  infoDiv: {
    border: `1px solid #00A2FF`,
    p: 1.5,
    mb: 2,
    mt: 1,
    bgcolor: "#00A2FF50",
    color: "#0989D1",
    fontSize: theme.palette.textSize.sm,
    fontWeight: 400,
  },

  bvnSteps: {
    border: `1px solid #F59E0B`,
    borderRadius: 1,
    p: 2,
    bgcolor: "#F59E0B10",
  },

  bvnCheck: {
    border: `1px solid #CB8000`,
    borderRadius: 1,
    p: 2,
    mb: 3,
    bgcolor: "#fff",
  },

  successToast: {
    background: "#FFFCF0",
    color: "#DC7609",
    border: "1px solid #DC7609",
    position: "relative",
  },

  successIconDiv: {
    width: 86,
    height: 86,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#2ECC7133",
    boxShadow: `0 2px 10px rgba(0,0,0,0.06)`,
  },

  successIcon: {
    width: 86,
    height: 86,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#2ECC7133",
    boxShadow: `0 2px 10px rgba(0,0,0,0.06)`,
  },

  walletCard: {
    borderRadius: 2,
    overflow: "hidden",
    mb: 2,
    color: "#fff",
    background:
      "linear-gradient(170deg, #0a0a0a 40%, #2e1a47 60%, #ff9f45 75%, #7ef29d 90%)",
  },

  addWalletBtn: {
    mt: 1,
    textTransform: "none",
    bgcolor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: 0,
    borderRadius: 2,
  },

  walletActive: {
    bgcolor: "#2ECC71",
    px: 1,
    py: "6px",
    borderRadius: 2,
    fontWeight: 400,
    fontSize: 12,
    color: "#fff",
  },

  paperDiv2: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1.5,
    py: 0.3,
    bgcolor: theme.palette.background.paper,
  },

  skipBtn: {
    textTransform: "none",
    borderColor: theme.palette.divider,
    py: 1.5,
    borderRadius: 2,
    bgcolor: "#BCB5B2",
    color: "#000",
  },

  forgotRootDiv: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#fafafa",
    p: 2,
  },

  tabsMainDiv: {
    display: "flex",
    gap: 1,
    bgcolor: theme.palette.primary.main,
    borderRadius: 1,
    p: 0.5,
    boxShadow: 1,
    width: "100%",
  },

  btnActive: {
    px: 3,
    backgroundColor: theme.palette.background.paper,
    textWrap: "nowrap",
  },

  btnInActive: {
    px: 3,
    color: theme.palette.text.primary,
    textWrap: "nowrap",
  },

  productIcon: {
    width: 72,
    height: 72,
    borderRadius: "0.5rem",
    border: `1px solid ${theme.palette.border.thin}`,
    objectFit: "contain",
  },

  borderNotActive: {
    borderRadius: 2,
    mt: 2,
    border: `1px solid ${theme.palette.border.thin}`,
  },

  borderActive: {
    borderRadius: 2,
    mt: 2,
    border: `2px solid ${theme.palette.primary.main}`,
  },

  loaderDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },

  ordSuccess: {
    mt: 3,
    pb: 15,
    bgcolor: theme.palette.user.bgColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  paperDiv3: {
    width: { xs: "100%", sm: 1080 },
    borderRadius: { xs: 1.5, md: 3 },
  },

  gridMainDiv: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "320px 1fr" },
    gap: 0,
    alignItems: "stretch",
  },

  ordSuccessleft: {
    p: { xs: 4, md: 5 },
    bgcolor: `linear-gradient(180deg, ${theme.palette.primary.main}22 0%, ${theme.palette.primary.main}08 100%)`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  successAnimation: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    mb: 2,
    mx: "auto",
    // ring + subtle bounce
    boxShadow: `0 10px 30px ${theme.palette.primary.main}20, inset 0 0 0 6px rgba(255,255,255,0.6)`,
    background:
      "linear-gradient(180deg, rgba(255,255,255,0.9), rgba(255,255,255,0.75))",
    position: "relative",
    "& .check": {
      width: 66,
      height: 66,
      borderRadius: "50%",
      background: theme.palette.primary.main,
      display: "grid",
      placeItems: "center",
      color: "#fff",
      transform: "scale(.92)",
      animation: "pulse 1200ms ease-in-out 5",
    },
    "@keyframes pulse": {
      "0%": { transform: "scale(.86)" },
      "60%": { transform: "scale(1.04)" },
      "100%": { transform: "scale(1)" },
    },
  },

  checkIcon: {
    width: 66,
    height: 66,
    bgcolor: theme.palette.primary.main,
  },

  avatarIcon: {
    width: 44,
    height: 44,
    bgcolor: theme.palette.primary.main + "22",
    color: theme.palette.primary.main,
    fontWeight: 700,
  },

  drawerPaper: {
    width: { xs: "100%", sm: 420 },
    padding: 2,
    bgcolor: "background.paper",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  summaryCard: {
    p: 2,
    borderRadius: 2,
    boxShadow: 1,
    bgcolor: "background.default",
  },

  smallMuted: { color: "text.secondary", fontSize: 13 },
  txnCard: {
    p: 1,
    borderRadius: 1,
    boxShadow: 0,
    border: 1,
    borderColor: "divider",
  },
  txnCard1: {
    p: 1,
    borderRadius: 1,
    boxShadow: 0,
    border: 1,
    borderColor: "divider",
    
  },
  amountCredit: { color: "success.main", fontWeight: 600 },
  amountDebit: { color: "error.main", fontWeight: 600 },
  amountPending: { color: "warning.main", fontWeight: 600 },

  schDate: {
    border: "1px solid #6556D9",
    borderRadius: 1,
    p: 1,
    background: "#6556D950",
    fontWeight: 600,
  },

  promoCode: {
    color: "green",
    fontSize: "12px",
    ml: 1,
    fontWeight: "600",
  },

  driverStatus: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    objectFit: "contain",
    position: "absolute",
    top: 12,
    right: 20,
    zIndex: 30,
    boxShadow: 1,
    color: "#FFFFFF",
    backgroundColor: "#F59E0B",
    border: `1px solid ${theme.palette.border.thin}`,
  },

  driverStatus2: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    objectFit: "contain",
    boxShadow: 1,
    color: "#FFFFFF",
    border: `1px solid ${theme.palette.border.thin}`,
  },

  orderMainDiv: {
    height: "80vh",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
    },
  },

  noDataDiv: {
    flex: 1,
    display: "flex",
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${theme.palette.border.thin}`,
    borderRadius: 2,
  },

  scroolBtm: {
    pb: 12,
  },

  closeIcon: {
    position: "absolute",
    top: 12,
    right: 20,
    zIndex: 30,
    bosizehadow: 1,
    color: "#FFFFFF",
    backgroundColor: "#F59E0B",
  },
  closeIcon1: {
    position: "absolute",
    top: 8,
    left: 8,
    zIndex: 20,
    bosizehadow: 1,
    color: "#FFFFFF",
    backgroundColor: "#F59E0B",
  },

  steperError: {
    "& .MuiStepLabel-label.Mui-active": {
      color: "error.main",
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: "error.main",
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: "error.main",
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: "error.main",
    },
  },

  steperClass: {
    "& .MuiStepIcon-root.Mui-active": {
      color: "#ccc !important" // highlight only active step
    },
    "& .MuiStepIcon-root": {
      color: "#ccc" // default grey
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: "#f5a623" // completed color
    }
  },

  carouselMainDiv: {
    borderRadius: 1,
    boxShadow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    border: `1px solid ${theme.palette.border.thin}`,
    cursor: "pointer",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    },
  },

  carouselImg: {
    width: "100%",
    height: { xs: 220, sm: 260, md: 260 },
    objectFit: "contain",
    transition: "transform 0.3s ease",
    "&:hover": { transform: "scale(1.05)" },
  },

  paymentDiv: {
    border: `1px solid ${theme.palette.border.thin}`, width: "100%", p: 0.4, borderRadius: 1, m: 0
  },

  stationCard: {
    width: 72, height: 72, mr: 1, objectFit: "contain", border: "1px solid #ccc", borderRadius: "5px"
  },

  
});
